import React from 'react';
import Modal from 'react-modal';
import update from 'immutability-helper';
import moment from 'moment'

import { financial } from '../../core/controllers/Financial';
import { modalStyles } from '../../core/controllers/ModalStyles';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { tenantBilling } from '../../core/controllers/TenantBilling';
import { billing } from '../../core/controllers/Billing';
import { modal } from '../../core/utilities/modal';
import { user } from '../../core/controllers/user';
import { quickBooksHandler } from '../../helpers/Integrations/QuickBooks/QuickBooksHandler'

import Income from '../../components/Financial/Income'
import Expense from '../../components/Financial/Expense'
import LateRent from '../../components/Financial/LateRent'
import FeesList from '../../components/Fees/FeesList';
import PropertiesSelect from '../../components/Properties/PropertiesSelect';
import LeaseSelect from '../../components/Leases/LeaseSelect';
import OwnersSelect from '../../helpers/Owner/OwnersSelect';
import WorkOrdersSelect from '../../helpers/WorkOrders/WorkOrdersSelect';
import InvoicesSelect from '../../helpers/Invoices/InvoicesSelect';
import FeesSelect from '../../helpers/Fees/FeesSelect';
import NavLink from '../../components/Routes/NavLink';
import QuickBooksActions from '../../components/QuickBooks/QuickBooksActions';
import QuickBooksDataExplorer from '../../components/QuickBooks/QuickBooksDataExplorer';
export default class QuickBooksTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            generalActive: 'active',
            requestDataActive: '',
            lastRun: ''
        }
    }

    componentDidMount() {
        var self = this;
        quickBooksHandler.getLastActivity(function(response) {
            self.setState({
                lastRun: response.last_run
            });
        });
    }

    handleTabChange(type) {
        if(type == 'general') {
            this.setState({
                generalActive: 'active',
                requestDataActive: ''
            });
        } else if (type == 'requestData') {
            this.setState({
                generalActive: '',
                requestDataActive: 'active'
            });
        }
    }

    /**
     * Formats money, if not value, return 0
     * @param {*} e
     */
    formatAmount(value) {
        // format money
        var money = parseFloat(value);
        if(isNaN(money) || money === 0) {
            money = 0;
        } else {
            money = money / 100;
        }

        return money;
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatMoney(cell, row) {
        var money = this.formatAmount(cell);
        var cssClass = "positive";
        if(money < 0) {
            cssClass = "negative";
        }


        money = Number(money.toFixed(2)).toLocaleString()
        money.toLocaleString("en-US", {style:"currency", currency:"USD"});

        return "<span class='table-"+cssClass+"'>$"+money+"</span>";
    }

    formatDate(cell, row) {
        return moment(cell).format('D MMM YYYY');
    }

    flattenObject(ob) {
        var toReturn = {};
        for (var i in ob) {
            if (!ob.hasOwnProperty(i)) continue;
            if ((typeof ob[i]) == 'object') {
                var flatObject = this.flattenObject(ob[i]);
                for (var x in flatObject) {
                    if (!flatObject.hasOwnProperty(x)) continue;
                    toReturn[x] = flatObject[x];
                }
            } else {
                toReturn[i] = ob[i];
            }
        }
        return toReturn;
    }

    handleTitleChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                title: {$set: e.target.value}
            }),
        });
    }

    handleTypeChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                type: {$set: e.target.value}
            }),
        });
    }

    changeDate(transaction) {
        this.setState({showDateModal: true, selectedTransaction: transaction});
    }

    handleNewDueDate(e) {
        this.setState({
            newDate: e.target.value
        });
    }

    render(){
        var self = this;
        const generalActive = this.state.generalActive;
        const requestDataActive = this.state.requestDataActive;
        const lastRun = this.state.lastRun;
        return (
        <div class="col-md-12">
            <div class="row">
                <div class="main-page-header-row col-md-12">
                    <div class="col-md-12 col-sm-12 col-xs-12">
                        <span class="main-page-header-title">Your QuickBooks Desktop Integration</span>
                    </div>
                    {/* { (generalActive == 'active' || transactionsActive == 'active') && (
                    <div class="col-md-2 col-md-offset-7 col-sm-6 col-xs-12">
                        <button type="button" id="add-transaction" data-loading-text="Loading..." class="btn btn-info btn-fill pull-right" autoComplete="off" onClick={this.handleOpenModal.bind(this, "add_transaction")}>
                            Add Transaction
                        </button>
                        <div class="clearfix"></div>
                    </div>
                    )} */}
                </div>
            </div>
            <br />
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <h4 class={"cross-tab-select " + generalActive} onClick={this.handleTabChange.bind(this, 'general')}>OVERVIEW</h4>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                        <h4 class={"cross-tab-select " + requestDataActive} onClick={this.handleTabChange.bind(this, 'requestData')}>SYNC DATA</h4>
                    </div>
                    {/* <div class="col-md-3 col-sm-6 col-xs-12">
                        <h4 class={"cross-tab-select " + feesActive} onClick={this.handleTabChange.bind(this, 'fees')}>FEES</h4>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12">
                        <h4 class={"cross-tab-select " + quickBooksActive} onClick={this.handleTabChange.bind(this, 'quickbooks')}>QUICKBOOKS</h4>
                    </div> */}
                </div>
            </div>
            { generalActive == 'active' && (
            <div>
                <div class="content">
                    <div class="row">
                        <div class="col-md-4 col-sm-6 col-xs-12">
                            <div class="info-box">
                                <span class="info-box-icon blue-icon-circle"><i class="icon-clock"></i></span>
                                <div class="info-box-content">
                                    <span class="info-box-text">Last Connection to QB </span>
                                    <br/>
                                    <span class="info-box-subtext"></span>
                                    <span class="info-box-number" style={{fontSize: "12px"}}>{moment(lastRun).local().format('MMMM Do YYYY, h:mm a')}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="card">
                                <div class="header">
                                    <h4 class="title">Data Explorer</h4>
                                    <p class="category">View recently synced data from QuickBooks.</p>
                                </div>
                                <QuickBooksDataExplorer />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            )}
            { requestDataActive == 'active' && (
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="header">
                            <h4 class="title">Run Actions against QuickBooks</h4>
                            <p class="category"></p>
                        </div>
                        <QuickBooksActions />
                    </div>
                </div>
            </div>
            )}
        </div>
        )
    }
};


// WEBPACK FOOTER //
// app/views/QuickBooks/QuickBooks.jsx